import styled, { css } from 'styled-components'

import { fromMd } from '@syconium/little-miss-figgy'

import { sectionGap } from './styles'

export const SizeChartLoadingState = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  ${fromMd} {
    min-height: 400px;
  }
  min-height: 100vh;
`

const sectionStack = css`
  ${sectionGap};
  display: flex;
  flex-direction: column;
`

export const Content = styled.div`
  ${sectionStack};
  padding: ${o => o.theme.spacing(6, 4, 12)};

  ${fromMd} {
    padding: ${o => o.theme.spacing(6, 10, 12)};
  }
`

export const TabPanel = styled.div`
  ${sectionStack};
`

export const Divider = styled.hr`
  background-color: ${o => o.theme.color.stroke.neutral.border.decoration.on.background};
  border: none;
  height: 1px;
  margin: 0;
`

export const HelpBox = styled.div`
  background-color: ${o => o.theme.color.fill.subtle};
  border-radius: ${o => o.theme.borderRadius.md};
  display: flex;
  flex-direction: column;
  gap: ${o => o.theme.spacing(2)};
  padding: ${o => o.theme.spacing(5)};
`

export const HelpBoxCtas = styled.div`
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  gap: ${o => o.theme.spacing(2)};
  padding-top: ${o => o.theme.spacing(2)};
`
